<script lang="ts">
  import DeletedComment from "./DeletedComment.svelte";
  import Comment from "./Comment.svelte";
  import { getContext } from "svelte";
  import type { Writable } from "svelte/store";
  import type { CommentsStateType } from "./MaterialComments.svelte";

  export let commentId: string | number

  let state: Writable<CommentsStateType> = getContext('comments')

  $: comment = $state.comments[commentId]
</script>

{#if comment.comment_delete}
  {#if !comment.hide_deleted}
    <DeletedComment comment={comment}/>
  {/if}
{:else}
  <Comment commentId={commentId}/>
{/if}
